import CopyToClipboardTextInput from 'components/Form/Inputs/CopyToClipboardTextInput';
import Modal from 'components/Modal';
import routeMap from 'config/routes';
import React from 'react';

const ManualShareModal = ({ close, labelId }) => (
  <Modal
    title="Manually Share Invite"
    subtitle={
      <>
        Invites are sent based on artist preferences (Thursdays by default). To avoid spam
        our app does NOT support automatic/in-app reminders. However, if you&apos;re in
        touch personally with them, try sharing this mobile friendly URL.
      </>
    }
    onClose={close}
  >
    <CopyToClipboardTextInput
      className="mt-3"
      text={`https://protonradio.com${routeMap.inbox.root}${routeMap.inbox.subscriptions}?label_id=${labelId}`}
    />
  </Modal>
);

export default ManualShareModal;
